import { Observable } from "rxjs";
import { suche } from "@progressive-development/politik-model";

import { ladeJahresListe } from "../../../common/artefakte/artefakt-lader.js";

/** Die Sitzungen-Liste: alle Jahre auf einmal (FACHKONZEPT-termine.md, 8.5). */
export interface SitzungenListe {
  manifest: suche.SitzungenListeManifest;
  eintraege: suche.SitzungenEintrag[];
}

export class SitzungenService {
  public ladeListe(): Observable<SitzungenListe> {
    return ladeJahresListe<suche.SitzungenListeManifest, suche.SitzungenEintrag>(
      suche.SITZUNGEN_LISTE_MANIFEST,
    );
  }
}

export const sitzungenService = new SitzungenService();
